var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4807 7.26953L7.96713 7.36127C7.59359 7.3749 7.29769 7.68172 7.29769 8.05555V10.4525M12.3394 12.3112L7.71596 7.71097",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 15.5807C20.1665 13.8523 20.1665 12.988 19.6295 12.451C19.0926 11.9141 18.2283 11.9141 16.4998 11.9141H15.5832C13.8547 11.9141 12.9904 11.9141 12.4535 12.451C11.9165 12.988 11.9165 13.8523 11.9165 15.5807V16.4974C11.9165 18.2259 11.9165 19.0901 12.4535 19.6271C12.9904 20.1641 13.8547 20.1641 15.5832 20.1641H16.4998C18.2283 20.1641 19.0926 20.1641 19.6295 19.6271C20.1665 19.0901 20.1665 18.2259 20.1665 16.4974V15.5807Z",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 7.79427V9.6276M9.1665 1.83594H12.8332M1.83317 12.8359V9.16927M9.62484 20.1693H7.7915M20.1116 5.04427C19.9705 4.06749 19.6958 3.37505 19.1616 2.84083C18.6274 2.30662 17.935 2.03198 16.9582 1.89081M5.0415 1.89081C4.0647 2.03198 3.37225 2.30662 2.83811 2.84083C2.30388 3.37505 2.02925 4.06749 1.88808 5.04427M1.88808 16.9609C2.02925 17.9377 2.30388 18.6302 2.83811 19.1643C3.37225 19.6986 4.0647 19.9732 5.0415 20.1144",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/full screen.34711cbdf1ccbb2f476a4f017b60386f.svg";
export { ForwardRef as ReactComponent };